/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_list__aria_label__filter_button_filtered__many = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} aktivierte Filter`
};

const en_poi_list__aria_label__filter_button_filtered__many = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} activated filters`
};

const es_poi_list__aria_label__filter_button_filtered__many = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} filtros activados`
};

const fr_poi_list__aria_label__filter_button_filtered__many = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} filtres activés`
};

const it_poi_list__aria_label__filter_button_filtered__many = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} filtri attivati`
};

const nl_poi_list__aria_label__filter_button_filtered__many = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} geactiveerde filters`
};

const pt_poi_list__aria_label__filter_button_filtered__many = /** @type {(inputs: { numberOfFilters: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.numberOfFilters} filtros activados`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ numberOfFilters: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__many = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_list__aria_label__filter_button_filtered__many(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_list__aria_label__filter_button_filtered__many", locale)
	if (locale === "de") return de_poi_list__aria_label__filter_button_filtered__many(inputs)
	if (locale === "en") return en_poi_list__aria_label__filter_button_filtered__many(inputs)
	if (locale === "es") return es_poi_list__aria_label__filter_button_filtered__many(inputs)
	if (locale === "fr") return fr_poi_list__aria_label__filter_button_filtered__many(inputs)
	if (locale === "it") return it_poi_list__aria_label__filter_button_filtered__many(inputs)
	if (locale === "nl") return nl_poi_list__aria_label__filter_button_filtered__many(inputs)
	return pt_poi_list__aria_label__filter_button_filtered__many(inputs)
};